module.exports = __webpack_public_path__ + "static/media/cloud-c-v3.9d58b73d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-c-v3.svg
// module id = 96
// module chunks = 0